import { Page } from '@common/ui/Page';
import routes from '@routes';
import { Outlet } from 'react-router-dom';

export default function NewRequestLayout() {
  return (
    <Page
      title="New Request"
      breadcrumbs={[{ label: 'My Requests', href: routes.OpenRequests.path }]}
      tabs={[
        { label: routes.NewRequest.label, to: routes.NewRequest.path },
        { label: routes.BundleRequest.label, to: routes.BundleRequest.path },
      ]}
    >
      <Outlet />
    </Page>
  );
}
